// extracted by mini-css-extract-plugin
export default {"modal":"v0-z","addItemButton":"w0-z","plusCircle":"x0-z","branchVisible":"y0-z"};